export const endpoints = {
  auth: '/smart-ura-realm',
  call: 'call?extension=:ramal&phoneNumber=:phoneNumber',
}
